import { type DirectiveBinding, type App } from 'vue'
import trackEvent from '@/track/trackEvent'

interface Params {
  [key: string]: any
}
interface BuriedPointParams {
  name: string
  params: Params
}

export default (app: App) => {
  app.directive('track', {
    mounted(el: HTMLElement, binding: DirectiveBinding<BuriedPointParams>) {
      const { name, params } = binding.value
      // 检查必填参数
      if (!name) {
        console.error('埋点事件名称必须提供')
        return
      }

      // 定义点击事件处理函数
      const handleClick = () => {
        trackEvent.track(name, { ...params })
      }
      el.addEventListener('click', handleClick)
      ;(el as any)._trackClickHandler = handleClick
    },
    beforeUnmount(el: HTMLElement) {
      // 移除点击事件监听器
      const handleClick = (el as any)._trackClickHandler
      if (handleClick) {
        el.removeEventListener('click', handleClick)
        delete (el as any)._trackClickHandler
      }
    }
  })
}
